import React, { SVGProps } from 'react';

const SettlementPrices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="SettlementPrices">
    <path
      d="M12.167 12.333h1.666v-10H5.5V4h6.667v8.333Zm0 1.667v2.5c0 .46-.375.833-.84.833H1.34A.835.835 0 0 1 .5 16.5L.502 4.833c0-.46.375-.833.84-.833h2.491V1.5a.833.833 0 0 1 .834-.833h10a.833.833 0 0 1 .833.833v11.667a.833.833 0 0 1-.833.833h-2.5ZM2.169 5.667l-.002 10H10.5v-10H2.17Zm1.664 6.666h3.75a.417.417 0 0 0 0-.833h-2.5a2.083 2.083 0 0 1 0-4.167H5.5V6.5h1.667v.833h1.666V9h-3.75a.417.417 0 0 0 0 .833h2.5a2.083 2.083 0 1 1 0 4.167h-.416v.833H5.5V14H3.833v-1.667Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default SettlementPrices;
